import React, {Component} from 'react';

class EuProjectPage extends Component {
	render() {
		return (
			<div className="container-flex">
				<div className="page__banner page__banner--eu-project">
					<h2>Nyertes pályázat</h2>
				</div>
				<div className="page">
					<div className="page__content page__content--eu-project">
						<article className="eu-project">
							<h3>Prototípusfejlesztés – VEKOP</h3>
							<ul>
								<li>Kedvezményezett neve: EDICTUM Kereskedelmi és Tanácsadó Korlátolt Felelősségű Társaság</li>
								<li>Projekt címe: Smart home rendszerfejlesztés az Edictum Kft-nél.</li>
								<li>Szerződött támogatás összege: 79 596 401 Ft</li>
								<li>Támogatás mértéke: 60,83%</li>
								<li>Projekt tervezett befejezési dátuma: 2019.12.31.</li>
								<li>Projekt azonosító száma: VEKOP-2.1.7-15-2016-00398</li>
							</ul>
							<h4>Projekt leírás:</h4>
							<p>A projekt keretében egy átfogó smart home megoldás kerül kifejlesztésre,
								melynek lényege és célja, hogy a meglévő, legkülönbözőbb otthonok is smart home
								megoldások befogadására alkalmassá váljanak. A projekt keretében emellett a piaci bevezetés
								megalapozása is megtörténik. A projekt alapötlete az az alapgondolat, hogy ne csak az újonnan
								kialakításra kerülő házak és lakások valamint a nagy költségek mellett felújított otthonok
								lehessenek smart home-ok, hanem minden lakás akár nagyon alacsony induló költséggel is smart home
								lehessen vagy elindulhasson a teljes rendszer felé vezető úton.</p>
						</article>
						<article className="eu-project">
							<h3>VIR - GINOP</h3>
							<ul>
								<li>Kedvezményezett neve: EDICTUM Kereskedelmi és Tanácsadó Korlátolt Felelősségű Társaság</li>
								<li>Projekt címe: Felhőalapú vállalatirányítási rendszer bevezetése az EDICTUM Kft.-nél</li>
								<li>Szerződött támogatás összege: 7 999 750 Ft</li>
								<li>Támogatás mértéke: 39,99%</li>
								<li>Projekt tervezett befejezési dátuma: 2020.04.30</li>
								<li>Projekt azonosító száma: GINOP-3.2.2-8-2-4-16-2017-00091</li>
							</ul>
							<h4>Projekt leírás:</h4>
							<p>
								A projekt keretein belül felhő alapú (cloud) integrált CRSM rendszer kerülne bevezetésre.
								A projekt célja a bevezetendő rendszerrel a meglévő részfeladatok egységesítése, összehangolása,
								a kezelhetőség javításával komplex, integrált rendszer létrehozása. A kialakítandó rendszer
								segítségével strukturáltabb és összefüggőbb tevékenység valósulhat meg, amely nagymértékben
								optimalizálná a vállalkozás működését, a telephelyek közötti kommunikációját és napi szintű
								együttműködését. Az integrált rendszer bevezetése költség-, és időhatékonyabb gazdálkodást tesz
								lehetővé. A meglévő számlázó, raktárkezelő rendszer integrálása és az új projektelemek
								kialakítása több funkcionális terület bevezetésével valósul meg.
							</p>
						</article>
					</div>
				</div>
			</div>
		);
	}
}

export default EuProjectPage;


// WEBPACK FOOTER //
// ./src/components/page/EUProjectPage.js